// Deze site is voor 12-18 jaar; ervaringen van 19 tot en met 30 jaar tonen we niet.
const isForThisSite = (item) => {
  const age = item && item.fields && item.fields.leeftijd;
  return !(age >= 19 && age <= 30);
};

export const forThisSite = (items) => (items || []).filter(isForThisSite);

export default isForThisSite;
